const { getOffsetTop } = window.BAO.Utils

class FixedBar extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.style.minHeight = this.children[0].offsetHeight + 'px'

    this.isTicking = false
    this.lastKnownY = window.scrollY

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)

    this.updateEl()
  }

  setupListeners () {
    super.setupListeners()

    this.onScroll = this.onScroll.bind(this)

    this.listeners.add(window, 'scroll', this.onScroll)
  }

  onScroll () {
    this.lastKnownY = window.scrollY

    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.setFixed()
    this.setVisibility()
  }

  setFixed () {
    this.els['product-form'].element.setAttribute('data-fixed', this.shouldBeFixed)
  }

  get shouldBeFixed () {
    const formFooter = this

    if (
      this.lastKnownY > getOffsetTop(formFooter) + formFooter.offsetHeight + 40
    ) {
      return true
    } else {
      return false
    }
  }

  setVisibility () {
    this.els['product-form'].element.setAttribute('aria-hidden', !this.shouldBeVisible)
  }

  get shouldBeVisible () {
    const formFooter = this
    const pageFooter = document.querySelector('#shopify-section-footer')

    if (
      this.lastKnownY > getOffsetTop(formFooter) + formFooter.offsetHeight + 75 &&
      this.lastKnownY < getOffsetTop(pageFooter) - window.innerHeight
    ) {
      return true
    } else {
      return false
    }
  }
}

if (!customElements.get('fixed-bar')) {
  customElements.define('fixed-bar', FixedBar)
}
